import { MenuItem, Stack } from "@mui/material";
import Button from "components/Button";
import DatePicker from "components/DatePicker";
import Dropdown from "components/Dropdown";
import SearchBar from "components/SearchBar";
import { VIEW_INTERVAL_OPTIONS_JOURNAL } from "constants/index";
import dayjs from "dayjs";
import _debounce from "lodash/debounce";
import { useCallback } from "react";

export const Filter = ({ params, defaultParams, onChange, onClickAddRecord }) => {
  const onChangeHandler = (e) => {
    let { name, value } = e.target;
    let result = {};
    result[name] = value;
    if (name === "view_options" && value === "CUSTOM") {
      result["date_from"] = dayjs().subtract(15, "day").format("YYYY-MM-DD");
      result["date_to"] = dayjs().format("YYYY-MM-DD");
    } else if (name === "view_options") {
      result["date_from"] = "";
      result["date_to"] = "";
    }
    onChange(result);
  };

  const onChangeDateHandler = (key, m) => {
    const date = dayjs(m).format("YYYY-MM-DD");
    if (date === "Invalid Date") {
      onChange({ [key]: "" });
    } else {
      onChange({ [key]: date });
    }

    if (key === "date_from") {
      params["from"] = new Date(m);
    }

    if (key === "date_to") {
      params["to"] = new Date(m);
    }
  };

  const handleDebounceFn = (inputValue) => {
    onChange({ search: inputValue });
  };

  const debounceFn = useCallback(_debounce(handleDebounceFn, 500), [onChange]);

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      mt="40px"
      flexWrap="wrap"
    >
      <Stack direction="row" gap={2} mb={2}>
        <Dropdown
          name="view_interval_options"
          labelId="View Options"
          label="View Options"
          className="base-dropdown"
          value={params.view_interval_options}
          defaultValue={defaultParams.view_interval_options}
          onChange={onChangeHandler}
        >
          {VIEW_INTERVAL_OPTIONS_JOURNAL.map((item) => (
            <MenuItem key={item.value} value={item.value}>
              {item.label}
            </MenuItem>
          ))}
        </Dropdown>
        {params.view_interval_options === "CUSTOM" && (
          <>
            <DatePicker
              label="Date From"
              className="base-dropdown"
              value={params.from}
              onChange={(m) => onChangeDateHandler("date_from", m)}
            />
            <DatePicker
              label="Date To"
              className="base-dropdown"
              value={params.to}
              onChange={(m) => onChangeDateHandler("date_to", m)}
            />
          </>
        )}
      </Stack>

      <Stack direction="row" gap={1} mb={2}>
        <SearchBar value={params.search} onSearch={debounceFn} />
        <Button
          label="Add Record"
          className="refresh-report-btn margin-0"
          color="primary-blue"
          onClick={onClickAddRecord}
        />
      </Stack>
    </Stack>
  );
};
